<template>
  <div class="Home">
    <!-- 版心 -->
    <div class="_center WidCon">
      <!-- 切换显示内容 -->
      <div class="conent">
        <div class="conent_box">
          <h3>师资培养</h3>
          <i class="selected"></i>
          <div class="_text">践行能力的传递者，助力高水平师资队伍建设</div>
          <div class="form">
            <ul class="form_box1">
              <li></li>
              <li></li>
            </ul>
          </div>
          <div class="training">
            <ul>
              <li>
                <img src="../../../../assets/BigData7.png" alt />
                <p class="training_text">
                  华为HCIA- Big Data、HCIP-BigData De- veloper、HCIP-Big Data Operating &
                  Maintence
                </p>
              </li>
              <li>
                <img src="../../../../assets/BigData8.png" alt />
                <p class="training_text">学术交流讲座</p>
              </li>
              <li>
                <img src="../../../../assets/training3.png" alt />
                <p class="training_text">教师顶岗实践</p>
              </li>
            </ul>
          </div>
        </div>
        <div class="Divider"></div>
        <div class="conent_box resources">
          <h3>教材开发</h3>
          <i class="selected"></i>
          <div class="_text">践行能力的传递者，助力高水平师资队伍建设</div>
          <!-- 课程 -->
          <div class="course">
            <div class="course_box">
              <ul class="form_box">
                <li>
                  <div>
                    <img src="../../../../assets/skill1.png" alt />
                  </div>
                  <h3>职业素养课程体系建设</h3>
                  <p>
                    结合华为企业文化与管理实践，以能力为本位，以精准就业为导向，根据职业岗位对岗位素质素养的要求，构建知识结构体系，开发适应市场需求和学生长期发展的职业素养课程。
                  </p>
                </li>
                <li>
                  <div>
                    <img src="../../../../assets/skill2.png" alt />
                  </div>
                  <h3>岗位技能课程体系建设</h3>
                  <p>
                    企业参与教学，课堂衔接市场。企业与学院共同参与制订人才培养计划、授课计划和教材编写工作。突出专业特色，实训环节体现工学结合的教学模式；与企业密切合作，形成教改科研的联合体，根据职业岗位能力要求制定出课程标准；对该课程形成一支业务过硬、企业经验丰富、在行业具有影响力的“双师结构”的专兼职教学团队。
                  </p>
                </li>
                <li>
                  <div>
                    <img src="../../../../assets/skill3.png" alt />
                  </div>
                  <h3>联合教材编写</h3>
                  <p>
                    与校外实训基地的企业进行联合开发，聘请企业专家担任兼职教师，进行实训课程的授课任务。按基于工作过程的学习情境设计教学单元，院校老师于企业专家共同编写出版理论实践一体化的教材。
                  </p>
                </li>
                <li>
                  <div>
                    <img src="../../../../assets/skill4.png" alt />
                  </div>
                  <h3>在线资源建设</h3>
                  <p>
                    开发课程教学网站，完成特色教材、课程标准、网络课堂、电子教案、多媒体课件，建设课程网站、立体化教材和建设优质化核心课程。
                  </p>
                </li>
              </ul>
            </div>
            <div class="course_img">
              <div class="pink"></div>
              <div class="pink_img">
                <img src="../../../../assets/BigData9.png" alt />
              </div>
            </div>
          </div>
        </div>
        <div class="Divider"></div>
        <div class="conent_box classroom_box">
          <h3>教法设计</h3>
          <i class="selected"></i>
          <div class="_text">项目制、情景式教学，深化校企联合培养应用型人才</div>
          <ul class="classroom">
            <li>
              <div class="classroomImg">
                <img src="../../../../assets/classroom1.png" alt />
              </div>
              <div class="classroom_text">
                <h3>校内课堂</h3>
                <p>
                  大力推进“课堂革命”，借鉴“情境认知”学习理论和教学工厂的教学模式，让学生以“职业人”的身份在品牌企业工作环境中自主工作、独立学习、共同研讨，在完成工作任务和解决工作难题过程中，获得分析和解决问题的能力，锻炼在职业化情境中进行沟通与合作的能力。
                </p>
              </div>
            </li>
            <li>
              <div class="classroomImg">
                <img src="../../../../assets/classroom2.png" alt />
              </div>
              <div class="classroom_text">
                <h3>网络课堂</h3>
                <p>
                  开发网络课堂，建设智慧学习环境。利用移动互联网、物联网、云计算等为载体，构建课程资源丰富、内容适时更新、专业特色明显、学习管理便捷、对外开放共享的智慧学习技术体系和学习平台，为每个学生构建“虚拟学习空间”，满足学生随时随地学习、沟通、答疑、解惑等学习需要。
                </p>
              </div>
            </li>
            <li>
              <div class="classroomImg">
                <img src="../../../../assets/classroom3.png" alt />
              </div>
              <div class="classroom_text">
                <h3>企业课堂</h3>
                <p>
                  建立企业课堂，创新实践教学。将华为的训战体系与而学校的人才培养体系相融合，聚焦真实场景和任务，按照实际工作流程设计学习方案。通过“训”的结果和学员在“作战”任务中的表现综合判断授课效果。
                </p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { Vue, Prop, Component, Watch } from "vue-property-decorator";

@Component({
  components: {
    
  }
})
export default class Practice extends Vue {
  list= {
        style: {
          "background-image": `url(${require("../../../../assets/banner_certification.png")})`,
          height: "493px",
        },
        font1: "人工智能专业建设",
        font2: "",
        font3: "",
        font4: "全场景、端到端",
        font5: "培养智能时代智慧人才",
        button: "",
      }
      setSelcted(index) {
      this.$refs.carousel.setActiveItem(index);
    }
}
</script>
<style lang="less" scoped>
// 切换导航栏显示内容
._center {
  padding-bottom: 3.4375rem;
}
.conent {
  background-color: #f8f8f8;
  .Divider {
    height: 1.5625rem;
    width: 100%;
    background-color: #fff;
  }

  .conent_box {
    // height: 500px;
    padding: 2.8125rem 5rem 0;
    h3 {
      font-size: 1.75rem;
      text-align: center;
      color: #333;
    }
    .selected {
      display: block;
      width: 1.5625rem;
      height: 0.1875rem;
      background-color: #333333;
      margin: 0.625rem auto 0;
    }
    ._text {
      width: 100%;
      text-align: center;
      color: #999999;
      margin: 1.25rem auto 1.875rem;
    }
    .form {
      width: 100%;
      .form_box1 {
        display: flex;
        justify-content: space-between;
        li {
          margin: 0 auto;
          width: 574px;
          height: 335px;
          &:nth-child(1) {
            background: url(../../../../assets/aims22.png) no-repeat center center;
            background-size: contain;
            width: 100%;
          }
          &:nth-child(2) {
            background: url(../../../../assets/aims23.png) no-repeat center center;
            background-size: contain;
            width: 100%;
          }
        }
      }
    }
    // 培训
    .training {
      padding-bottom: 3.125rem;
      ul {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        li {
          position: relative;
          margin-top: 2rem;
          width: 22.625rem;
          height: 15.75rem;
          border-radius: 0.625rem;
          overflow: hidden;
          display: flex;
          justify-content: center;
          img {
            width: 100%;
          }
          .training_text {
            span {
              font-size: 12px;
              display: block;
              color: #ccc;
              font-weight: 200;
            }
            font-size: 16px;
            color: rgb(255, 255, 255);
            font-weight: bold;
            line-height: 1.2;
            text-align: left;
            position: absolute;
            bottom: 1.25rem;
            width: 100%;
            padding: 0 20px;
          }
        }
      }
    }
  }
  // 教材开发
  .resources {
    padding: 2.8125rem 5.625rem 0;
    // 课程
    .course {
      margin-top: 5rem;
      display: flex;
      .course_box {
        display: flex;
        flex-direction: column;
        flex: 1;
        font-size: 1.5rem;
        .form_box {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          li {
            width: 45%;
            padding-bottom: 2.5rem;
            h3 {
              text-align: left;
              font-size: 1.5rem;
              font-weight: 700;
              color: #333;
              padding: 0.625rem 0 0.3125rem;
            }
            p {
              font-size: 0.875rem;
              color: #555;
            }
          }
        }
      }
      .course_img {
        flex: 1;
        display: flex;
        justify-content: flex-end;
        overflow: hidden;
        position: relative;
        margin-left: 20px;
        .pink {
          width: 428px;
          height: 428px;
          background-color: pink;
        }
        .pink_img {
          position: absolute;
          top: 4rem;
          right: 4rem;
          width: 428px;
          height: 428px;
          background-color: pink;
          overflow: hidden;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
  // 教法设计
  .classroom_box {
    padding: 2.8125rem 4rem 0;
    // 教法设计
    .classroom {
      display: flex;
      justify-content: space-between;
      padding-bottom: 2.5rem;
      li {
        width: 24.75rem;
        background-color: #fff;
        border-radius: 0.3125rem;
        box-shadow: 0px 6px 10px 0px rgba(0, 0, 0, 0.07);
        .classroomImg {
          width: 100%;
          height: 16.75rem;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .classroom_text {
          padding: 1.25rem;
          color: #333;
          h3 {
            font-size: 1.5rem;
            text-align: left;
          }
          p {
            font-size: 0.875rem;
            line-height: 180%;
            padding: 0.625rem 0 1.875rem;
            text-align: justify;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 1366px) {
  .WidCon {
    padding: 0 5%;
  }
  .conent .conent_box .form .form_box1 li:nth-child(n) {
    width: 45%;
  }
  .conent .classroom_box .classroom li,
  .conent .conent_box .training ul li {
    width: 32%;
  }
}
@media screen and (max-width: 1200px) and (min-width: 901px) {
  .conent .resources .course .course_img {
    display: none;
  }
  // .conent .developing_box .developing {
  //   flex-wrap: wrap;
  // }
  // .conent .developing_box .developing li {
  //   border: none;
  // }
}
@media screen and (max-width: 985px) and (min-width: 769px) {
  .conent .resources .course .course_img {
    display: none;
  }
}
@media screen and (max-width: 768px) {
  // 背景
  .Banner {
    .BannerFont {
      h1 {
        font-size: 24px;
      }
      p,
      div {
        font-size: 20px;
      }
    }
  }
  // 导航
  .ExpertNav ul {
    flex-wrap: wrap;
    justify-content: space-evenly;
    li {
      border-left: 1px solid #ccc;
      margin-top: 0.3125rem;
    }
  }
  .conent {
    // 师资培养
    .conent_box {
      padding: 0 0.625rem;
      .form {
        .form_head {
          flex-direction: column;
          li {
            width: 100%;
          }
        }
        .form_bottom {
          li {
            width: 100%;
          }
        }
        .form_box {
          flex-direction: column;
          li {
            margin-top: 10px;
            padding: 10px 0;
            width: 100%;
            background: none !important;
            overflow: hidden;
            .Level1_right {
              padding: 10px;
              .Level2_left {
                p {
                  text-align: center;
                }
              }
            }
            .Level1_left {
              p {
                color: #333;
                text-align: center;
              }
            }
            .Level1_center {
              left: 1000000%;
            }
            &:nth-child(2) {
              background: #fff url("../../../../assets/Level2.png") no-repeat 50% 50%;
              justify-content: space-around;
              .Level2_con {
                flex: 1;
                display: flex;
                flex-direction: column;
                justify-content: space-evenly;
                // align-items: center;
                padding: 0 0.875rem;
                color: #fff;
                font-size: 0.875rem;
                .Level2_right {
                  text-align: right;
                }
                .Level2_left {
                  text-align: left;
                }
              }
              .Level2 {
                flex: 1;
                display: flex;
                flex-direction: column;
                justify-content: space-around;
                font-size: 1rem;
                .Level2_left {
                  p {
                    flex: 1;
                    text-align: center;
                  }
                }
                .Level2_right {
                  p {
                    flex: 1;
                    text-align: center;
                  }
                }
                div {
                  color: #333;
                }
              }
              .Level2_cont {
                display: flex;
                justify-content: space-between;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 19.375rem;
                height: 8.75rem;
                div {
                  display: flex;
                  flex-direction: column;
                  justify-content: space-between;
                }
              }
            }
          }
        }
      }
      .training {
        ul {
          flex-direction: column;
          align-content: center;
        }
      }
    }
    // 教材开发
    .resources {
      .course {
        flex-direction: column;
        margin-top: 20px;
        .course_box {
          .form_box {
            li {
              width: 100%;
            }
          }
        }
      }
    }
    // 教法设计
    .classroom_box {
      .classroom {
        flex-direction: column;
        align-items: center;
        li {
          margin-top: 0.625rem;
          width: 100%;
          .classroomImg {
            height: auto;
          }
        }
      }
    }
  }

  .conent .conent_box .form .form_box1 {
    display: block;
  }

  .conent .conent_box .form .form_box1 li:nth-child(n) {
    height: 200px;
    width: 100%;
  }

  .conent .conent_box ._text {
    margin: 20px auto;
  }

  .conent .resources .course .course_img .pink {
    display: none;
  }

  .conent .resources .course .course_img .pink_img {
    display: none;
  }

  .conent .resources .course .course_img .pink_img img {
    display: none;
  }

  .conent .conent_box h3 {
    font-size: 18px;
  }

  .conent .conent_box {
    padding-top: 20px;
  }

  .conent .resources .course .course_box .form_box li {
    text-align: center;
  }

  .conent .resources .course .course_box .form_box li h3 {
    text-align: center;
    font-size: 16px;
    font-weight: bold;
  }

  .conent .classroom_box .classroom li .classroom_text h3 {
    font-size: 16px;
    font-weight: bold;
    text-align: center;
  }
  .conent .conent_box .training ul li {
    width: 100%;
  }
}
</style>
